let userinfo = {}

function getUserinfo() {
    let info = localStorage.getItem('userinfo')
    if (info) {
        userinfo = JSON.parse(info)
    }
}
let setUserinfo = (userinfo) => {
    if (!userinfo) { return }
    localStorage.setItem('userinfo', JSON.stringify(userinfo))
}

getUserinfo()
export default {
    userinfo,
    setUserinfo
}
